import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { ViewCategoryAction } from '../model/view-category-action.model';
import { ViewCategory } from '../model/view-category.model';

import { UpdateCategoryAction } from './update-category-action.action';

export function updateCategoryActionReducer(
    state: EventCentreDialogState,
    action: PayloadAction<
        ActionType.NOTI__EC__UPDATE_CATEGORY_ACTION,
        UpdateCategoryAction
    >,
): EventCentreDialogState {
    try {
        const nextCategories = state.categories.map<ViewCategory>((c) => {
            return {
                ...c,
                actions: c.actions?.map<ViewCategoryAction>((a) => {
                    if (a.name === action.payload.name) {
                        return {
                            ...a,
                            styleHidden: action.payload.modify === 'hidden',
                            styleDisabled: action.payload.modify === 'disabled',
                        };
                    }
                    return a;
                }),
            };
        });
        const nextCategory = nextCategories.find(
            (e) => e.categoryId === state.categoryId,
        );
        return {
            ...state,
            categories: nextCategories,
            category: nextCategory,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
